

export const searchChangeInTerms = ({data, searchValue}) => {
  data.forEach(d => {
    d.terms = d.terms.filter(t => t.startsWith(searchValue));
  });
  return data;
};


// WEBPACK FOOTER //
// ./src/utilities/searchChangeInTerms.js